import { ContentState, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import React, { useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useAppContext } from "./../../context/AppCtxProvider";
import { makeThemedStyles } from "./../../viewcomponents/utils";
const useStyles = ({
  disableBorders,
  rtl,
}: {
  disableBorders: boolean;
  rtl: boolean;
}) =>
  makeThemedStyles("RichTextViewer", (theme) => ({
    toolbar: {
      marginBottom: "0",
      borderTopLeftRadius: "1.22em",
      borderTopRightRadius: "1.22em",
      borderColor: "rgb(126, 135, 145, 0.27)",
      "& .rdw-dropdown-caretto": {
        "&open, &close": {
          right: rtl ? "unset" : "10%",
          left: !rtl ? "unset" : "10%",
        },
      },
    },
    editorWrapper: {
      marginTop: "0em",
      marginLeft: "13px",
    },
    editorContainer: {
      width: "100%",
      color: "#888",
      fontSize: "16px",
      cursor: "text",
      padding: "0.5em",
      border: "",
      borderTopWidth: "0",
      borderRadius: "1.22em",
      borderTopLeftRadius: "0",
      borderTopRightRadius: "0",
      "& *": {
        margin: 0,
      },
      overflow: "hidden",
    },
  }));
interface Props {
  value?: string;
}
function RichTextViewer(props: Props) {
  const { value } = props;
  const { rtl } = useAppContext();
  const classes = useStyles({ disableBorders: false, rtl })();
  const [editorState, setEditorState] = React.useState<EditorState>(
    EditorState.createEmpty()
  );
  function getEditorState(html: string) {
    const contentBlock = htmlToDraft(html);
    const contentState = ContentState.createFromBlockArray(
      contentBlock.contentBlocks
    );
    return EditorState.createWithContent(contentState);
  }
  useEffect(() => {
    setEditorState(getEditorState(value ?? ""));
  }, [value]);
  return (
    <Editor
      readOnly={true}
      toolbarHidden={true}
      toolbarClassName={classes.toolbar}
      toolbar={{}}
      editorState={editorState}
      wrapperClassName={classes.editorWrapper}
      editorClassName={classes.editorContainer}
    />
  );
}
export default RichTextViewer;
